import { KizenStepType } from 'pages/AutomationEngine/types';

import {
  AddErrorMessage,
  MessageDictionary,
} from 'pages/AutomationEngine/messageDictionary';

import { SourceVariableType } from 'pages/AutomationEngine/dialogs/VariableWizard/types';

import {
  mapApiSource,
  mapFlowSource,
} from 'pages/AutomationEngine/dialogs/VariableWizard/variable-types/variableDTO';

const forFlow = (
  apiObject: any,
  addErrorMessage: AddErrorMessage,
  messageDictionary: MessageDictionary,
  stepType: KizenStepType
) => {
  const { variable } = apiObject;
  const sources = apiObject.sources.map(
    mapFlowSource(variable?.id, messageDictionary, addErrorMessage)
  );

  const flow = {
    // type is clashing with step type so let's force it here now we have set assignmentType
    type: stepType,
    chosenVariable: {
      label: variable?.name,
      value: variable?.name.replaceAll(' ', '_'),
    },
    variable,
    sources,
  };
  return flow;
};

const forApi = (step: any) => {
  const { variable } = step.details;

  const sources: SourceVariableType[] = (step.details.sources || []).map(
    mapApiSource
  );

  const api = {
    ...step,
    details: {
      variable: variable?.name,
      sources,
    },
  };

  return api;
};

export const updateVariableDTO = { forApi, forFlow };
